import { render, staticRenderFns } from "./IdList.vue?vue&type=template&id=ec2e296a&"
import script from "./IdList.vue?vue&type=script&lang=js&"
export * from "./IdList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports